import {ReactComponent as G1} from "../../images/release/game/card/g1.svg";
import {ReactComponent as G2} from "../../images/release/game/card/g2.svg";
import {ReactComponent as G3} from "../../images/release/game/card/g3.svg";
import {ReactComponent as G4} from "../../images/release/game/card/g4.svg";
import {ReactComponent as G5} from "../../images/release/game/card/g5.svg";
import {ReactComponent as G6} from "../../images/release/game/card/g6.svg";
import {ReactComponent as G7} from "../../images/release/game/card/g7.svg";
import {ReactComponent as G8} from "../../images/release/game/card/g8.svg";
import {ReactComponent as G9} from "../../images/release/game/card/g9.svg";
import {ReactComponent as G10} from "../../images/release/game/card/g10.svg";
import {ReactComponent as G11} from "../../images/release/game/card/g11.svg";
import {ReactComponent as G12} from "../../images/release/game/card/g12.svg";

export const icons = [G1, G2, G3, G4, G5, G6, G7, G8, G9, G10, G11, G12]